import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import YourInfo from "./pages/YourInfo";
import Family from "./pages/Family";
import CurrentEducation from "./pages/CurrentEducation";
import CollegeUniversity from "./pages/CollegeUniversity";
import WorkActivities from "./pages/WorkActivities";
import Review from "./pages/Review";
import NoPage from "./pages/NoPage";
import Counselor from "./pages/Counselor";
import StudentThankyou from './pages/StudentThankyou';
import CounselorThankyou from './pages/CounselorThankyou';
import CounselorReview from './pages/CounselorReview';
// import ApplyNow from './pages/ApplyNow';
import StudentEntries from './pages/StudentEntries';
import StudentEntriesHome from './pages/StudentEntriesHome';

function App() {
 
  
  return (
    <Routes>
      <Route path="/" element={<YourInfo />} />
      {/* <Route path="/your-info" element={<YourInfo />} /> */}
      <Route path="/current-education" element={<CurrentEducation />} />
      <Route path="/family" element={<Family />} />
      <Route path="/college-university-considering" element={<CollegeUniversity />} />
      <Route path="/work-activities" element={<WorkActivities />} />
      <Route path="/review" element={<Review />} />
      <Route path="/counselor" element={<Counselor />} />
      <Route path="/counselor-review" element={<CounselorReview />} />
      <Route path="/counselor/thank-you/" element={<CounselorThankyou />} />
      <Route path="/student/thank-you/" element={<StudentThankyou />} />
      <Route path="/student-entries/:studentName" element={<StudentEntries />} />
      <Route path="/student-entries-home/" element={<StudentEntriesHome />} />
      <Route path="*" element={<NoPage />} />
    </Routes>
  );
}

export default App;
